var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Sample Images"}},[_c('v-container',[_c('SampleImages',{attrs:{"sample-id":_vm.$route.params.sampleId}}),_c('v-row',{staticClass:"pa-5"},[_c('v-btn',{attrs:{"color":"secondary","to":"/samples/browse"}},[_vm._v(" Return to Samples ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }